import request from 'services/axios';

export const postAuctionSuggest = async (payload: IPostSuggestionAuction) => {
  const {data} = await request.post(`/api/v2/market/price-suggestion`, {
    ...payload,
  });
  return data;
};
